// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__3wQjd","name":"LandingPage_name__37wGA","homeBtn":"LandingPage_homeBtn__1a5bQ","home_span":"LandingPage_home_span__elB7Z"};